import React from 'react'
import style from './Footer.module.scss'
import { useTranslation } from 'react-i18next'

export default function Footer() {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className={`${style.footer}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className={`${style.about}`}>
                            <h3>{t('footer.about.title')}</h3>
                            <p>
                                {t('footer.about.description')}
                            </p>
                            <div className={`${style.social}`}>
                                <a href="https://www.facebook.com/profile.php?id=61557561129171" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                                <a href="https://wa.me/201116666028" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-whatsapp"></i>
                                </a>
                                <a href="tel:+201116666028">
                                    <i className="fas fa-phone"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className={`${style.contact}`}>
                            <h3>{t('footer.contact.title')}</h3>
                            <ul>
                                <li>
                                    <i className="fas fa-map-marker-alt"></i>
                                    {t('footer.contact.address')}
                                </li>
                                <li>
                                    <i className="fas fa-phone"></i>
                                    {t('footer.contact.phone')}
                                </li>
                                <li>
                                    <i className="fas fa-envelope"></i>
                                    {t('footer.contact.email')}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className={`${style.quickLinks}`}>
                            <h3>{t('footer.quickLinks.title')}</h3>
                            <ul>
                                <li><a href="#about">{t('footer.quickLinks.about')}</a></li>
                                <li><a href="#services">{t('footer.quickLinks.services')}</a></li>
                                <li><a href="#product">{t('footer.quickLinks.products')}</a></li>
                                <li><a href="#contact">{t('footer.quickLinks.contact')}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={`${style.copyright}`}>
                    <p>{t('footer.copyright', { year: currentYear })}</p>
                </div>
            </div>
        </footer>
    )
}
